
export const AVERAGE = "AVERAGE"
const TIMESTAMPS = "timestamps"

interface apiDataPoint {
  ts: string,
  data?: {
    device_id: string,
    // id is used by LoRa devices to save bytes
    id: string,
    [key: string]: number | string
  }[]
  //at: number,
  //ap: number,
  [key: string]: any, //DELETE this 
}
//Every value here graphs to the map.
export interface GraphingMap {
  [key: string]: {
    name: string;
    unit: string;
  };
}
export const graphingMap: GraphingMap = {
  "p": { name: "pressure", unit: "millibar" },
  "v": { name: "velocity", unit: "m/s" },
  "t": { name: "temperature", unit: "C" },
  "d": { name: "direction", unit: "degrees" },
  "rp": { name: "water column height", unit: "cm" },
  "wl": { name: "water level", unit: "cm" },
  "discharge": { name: "discharge", unit: "m3/s" },
  "dp": { name: "wave height", unit: "cm" },
  "w": { name: "wave interval", unit: "seconds" },
  "ap": { name: "air pressure", unit: "millibar" },
  "at": { name: "air temperature", unit: "C" },
  // "ts2": { name: "timestamp", unit: "local" }
  // "ts": { name: "uptime", unit: "ms" },
  // "x": { name: "x", unit: "" },
}
const graphingMapKeys = Object.keys(graphingMap);

function createEmptyAveragingObject() {
  let obj: any = {}
  graphingMapKeys.forEach((key: string) => obj[key] = 0)
  return obj
}
function createEmptyArrayObject() {
  let obj: any = {}
  graphingMapKeys.forEach((key: string) => obj[key] = [])
  return obj
}
function createEmptyChartData() {
  let obj: any = {}
  graphingMapKeys.forEach((key: string) => obj[graphingMap[key].name] = { labels: [], datasets: [] })
  return obj
}
function createEmptyDfObject(dataframe: any, defaultValue: any = 0) {
  let obj: any = {}
  Object.keys(dataframe).forEach((key: string) => {
    obj[key] = {}
    Object.keys(dataframe[key]).forEach((metricKey: string) => {
      obj[key][metricKey] = defaultValue;
    })
  })
  return obj
}
function getSensorsDataFromDataPoint(datapoint: any) {
  let sensorData: any = {
    AVERAGE: createEmptyAveragingObject(),
  }
  let sensorCount = 0
  // console.log(datapoint)

  datapoint.data.forEach((sensor: any) => {
    let singleSensorData: any = {}
    //filter out every key that is not in graphingmap
    const metrics = Object.keys(sensor).filter((key: any) => graphingMapKeys.includes(key))

    metrics.forEach((metric: string) => {
      singleSensorData[metric] = sensor[metric]
      sensorData[AVERAGE][metric] += sensor[metric]
    })

    if ((sensor.device_id === undefined) && (!(sensor.id === undefined))) {
      sensor.device_id = sensor.id
    }
    if (sensor.device_id === "N26") {
      sensor.device_id = "7 m - N26"
    }
    else if (sensor.device_id === "N27") {
      sensor.device_id = "3 m - N27"
    }
    else if (sensor.device_id === "N28") {
      sensor.device_id = "5 m - N28"
      // delete sensor.v
      // delete sensor.d
    }
    // To get rid of database errors when direction is not sent,
    // we delete the direction from the graph, but not from database.
    // In database, the direction value (sensor.d) will be -1.
    if (sensor.d === -1) {
      delete sensor.d
    }
    // The ts2 is used to show the actual timestamp from the hub.
    // Used in csv
    sensor.ts2 = datapoint.ts
    sensorData[sensor.device_id] = singleSensorData

    // console.log(singleSensorData)
    sensorCount++
  })

  const avgKeys = Object.keys(sensorData[AVERAGE])
  avgKeys.forEach((key: string) => sensorData[AVERAGE][key] /= sensorCount)
  return sensorData
}

function makeDataFrames(apiData: any) {
  const data: any = {
  }
  apiData.forEach((dp: any) => {
    const sensorDataObj = getSensorsDataFromDataPoint(dp);
    const sensorDataKeys = Object.keys(sensorDataObj);
    for (const sensorKey of sensorDataKeys) {
      if (!data.hasOwnProperty(sensorKey)) {
        data[sensorKey] = createEmptyArrayObject()
        data[sensorKey][TIMESTAMPS] = []
      }

      for (const metricKey of graphingMapKeys) {
        data[sensorKey][metricKey].push(sensorDataObj[sensorKey][metricKey])
      }
      data[sensorKey][TIMESTAMPS].push(dp.ts)
    }

  })
  return data
}
function getMinMax(dataFrames: any) {
  let min = createEmptyDfObject(dataFrames)
  let max = createEmptyDfObject(dataFrames)

  const N = dataFrames[AVERAGE][TIMESTAMPS].length;

  for (let i = 0; i < N; i++) {

    Object.keys(dataFrames).forEach((sensorID: any) => {
      Object.keys(dataFrames[sensorID]).forEach((metric: any) => {
        if (dataFrames[sensorID][metric][i] && metric !== TIMESTAMPS) {
          if (i === 1) {
            min[sensorID][metric] = dataFrames[sensorID][metric][i]
            max[sensorID][metric] = dataFrames[sensorID][metric][i]
          }
          if (dataFrames[sensorID][metric][i] < min[sensorID][metric]) {
            min[sensorID][metric] = dataFrames[sensorID][metric][i]
          }
          if (dataFrames[sensorID][metric][i] > max[sensorID][metric])
            max[sensorID][metric] = dataFrames[sensorID][metric][i]
        }
      })
    })
  }
  //Find minimum of sensor miniminums/maximums
  //Assumes that min and max objects have same shape
  let trueMin :any = {}
  let trueMax :any = {}
  Object.keys(min).forEach((sensorID: any) => {
    Object.keys(min[sensorID]).forEach((metric: any) => {
      const name = graphingMap?.[metric]?.name;
      if(name){
        if(!trueMin.hasOwnProperty(name)){
          trueMin[name] = min[sensorID][metric]
          trueMax[name] = max[sensorID][metric]
        }
        if(min[sensorID][metric] < trueMin[name])
          trueMin[name] = min[sensorID][metric]
        if(max[sensorID][metric] > trueMax[name])
          trueMax[name] = max[sensorID][metric]
      }
    })
  })
  let stepSize:any = {}
  //Calculate step size
  Object.keys(trueMax).forEach((key:any)=>{
    const max = trueMax[key]
    const min = trueMin[key]

    let step = (max-min)/100
    if (step === 0) { step = 0.1; }
    stepSize[key] = step
  })
  return {min,max, trueMin,trueMax,stepSize }
}
function getHourlyAverages(dataFrames: any) {
  let hourlyAverages: any = [] //createEmptyDfObject(dataFrames,[])
  let avgDf: any = {}

  const N = dataFrames[AVERAGE][TIMESTAMPS].length;

  let hour = new Date(dataFrames[AVERAGE][TIMESTAMPS][0]).getHours()
  let count = 1
  for (let i = 0; i < N; i++) {
    const ts = dataFrames[AVERAGE][TIMESTAMPS][i]
    const currentHour = new Date(ts).getHours()
    Object.keys(dataFrames).forEach((sensorID: any) => {
      if (!avgDf.hasOwnProperty(sensorID))
        avgDf[sensorID] = {}
      Object.keys(dataFrames[sensorID]).forEach((metric: any) => {

        if (!avgDf[sensorID].hasOwnProperty(metric))
          avgDf[sensorID][metric] = 0
        avgDf[sensorID][metric] = parseFloat(avgDf[sensorID][metric]) + parseFloat(dataFrames[sensorID][metric][i])
      })
    })
    if (hour !== -1 && hour !== currentHour && count > 0) {

      Object.keys(avgDf).forEach((sensorID: any) => {

        if (!hourlyAverages.hasOwnProperty(sensorID))
          hourlyAverages[sensorID] = {}

        Object.keys(avgDf[sensorID]).forEach((metric: any) => {
          if (metric !== TIMESTAMPS) {
            if (!hourlyAverages[sensorID].hasOwnProperty(metric))
              hourlyAverages[sensorID][metric] = [avgDf[sensorID][metric] / count]
            else
              hourlyAverages[sensorID][metric].push(avgDf[sensorID][metric] / count)
          }
          
        })
        if (!hourlyAverages[sensorID].hasOwnProperty(TIMESTAMPS)) {
          hourlyAverages[sensorID][TIMESTAMPS] = [dataFrames[AVERAGE][TIMESTAMPS][i-count > 0 ? i-count : 0]] //push the hour where the averaging started
        }
        else{
          hourlyAverages[sensorID][TIMESTAMPS].push(dataFrames[AVERAGE][TIMESTAMPS][i-count > 0 ? i-count : 0])
        }
      })
      avgDf = {}
      hour = currentHour
      count = 0
    }

    count++
    hour = currentHour
  }
  return hourlyAverages
}
function getUnitMap(){
  //Maps metric name to unit for easier access in chart component
  let map :any = {}
  graphingMapKeys.forEach((key:string)=>{
    const name = graphingMap[key].name
    const unit = graphingMap[key].unit
    map[name] = unit
  })
  return map
}

export function makeChartData(apiData: apiDataPoint[], showAll: boolean, showRaw: boolean,showStdDev:boolean,sensorsOnGraph:string[]) {
  if (!apiData || apiData.length <= 0) return { pressure: { labels: [], datasets: [{ color: '', data: [], label: '' }] } }

  //Make dataframe for each sensor dynamically
  //Structure is "sensor_name":{"p":[], TIMESTAMPS:[]}

  let dataFrames = makeDataFrames(apiData)
  let { min,max, trueMin, trueMax, stepSize} = getMinMax(dataFrames)

  // if(!showAll){
  //   dataFrames = {AVERAGE:dataFrames[AVERAGE]}
  // }
  if (!showRaw) {
    dataFrames = getHourlyAverages(dataFrames);
  }

  let chartData: any = createEmptyChartData()

  const colors = ['red', 'blue', 'green', 'yellow']
  const unitMap = getUnitMap()
  Object.keys(dataFrames).forEach((device: any, index: number) => {
    const data = dataFrames[device]
    
    Object.keys(data).forEach((metric: any) => {
      if (metric !== TIMESTAMPS) {
        const name = graphingMap[metric].name
        // chartData[name].labels = data[TIMESTAMPS].map((ts:string)=>new Date(ts).toLocaleTimeString())
        // chartData[name].labels = data[TIMESTAMPS];
        chartData[name].labels = data[TIMESTAMPS].map((ts: string) =>
          ts
	    .replace(/\.\d+$/, '')
            .replace('T', ' ')     // replace T with space
        );
        if (device === AVERAGE) {
        chartData[name].datasets.push({
          hidden: true,
          label: device,
          data: data[metric],
          borderColor: colors[index],
          showStdDev:showStdDev,
          unit:unitMap[name]
        })
        }
        else {
        chartData[name].datasets.push({
          hidden: sensorsOnGraph.includes(device) ? false : !showAll,
          label: device,
          data: data[metric],
          borderColor: colors[index],
          showStdDev:showStdDev,
          unit:unitMap[name]
        })

        }
      }
    })
  })
  

  return {chartData, trueMin, trueMax,stepSize,unitMap}
}
